import {createFileRoute} from '@tanstack/react-router';

export const Route = createFileRoute('/_protected/home/accounts')({
  staticData: {crumbKey: 'navigation.accounts'},
});
